// outline blue button

import React from "react";

export default function DashedOutlineBtn({ children, onClick, className }) {
  return (
    <button
      className={"border-dashed rounded-2xl " + className}
      onClick={onClick}
      style={{
        borderColor: "#b7bdca",
        borderWidth: "1px",
      }}
    >
      {children}
    </button>
  );
}
